module.exports = __webpack_public_path__ + "img/river-rock-walk.db312d08.jpg";